import { Controller } from "@hotwired/stimulus"

// Shows the sticky app-download CTA unless the visitor has dismissed it for
// this creator. Dismissals are stored in localStorage so they persist across
// routine and product pages, but they expire after 7 days so returning
// visitors get nudged again.
const DISMISSAL_TTL_MS = 7 * 24 * 60 * 60 * 1000

export default class extends Controller {
  static targets = ["root"]
  static values = { storageKey: String }

  connect() {
    if (!this.dismissed()) {
      this.rootTarget.hidden = false
    }
  }

  dismiss() {
    try {
      window.localStorage.setItem(this.storageKeyValue, String(Date.now()))
    } catch (_error) {
      // Storage may be blocked (private mode, etc.); fall back to a session
      // dismissal by simply hiding the element.
    }
    this.rootTarget.hidden = true
  }

  trackClick() {
    // Hook for analytics — listeners can observe the event below.
    this.element.dispatchEvent(new CustomEvent("creator:app-download-click", { bubbles: true }))
  }

  dismissed() {
    try {
      const value = window.localStorage.getItem(this.storageKeyValue)
      if (!value) return false
      return Date.now() - parseInt(value, 10) < DISMISSAL_TTL_MS
    } catch (_error) {
      return false
    }
  }
}
